module.exports = __webpack_public_path__ + "static/img/girl-child.a60f854.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photos/girl-child.png
// module id = 211
// module chunks = 1